<div class="container">
    <div class="top">QR Money</div>
    <div class="bottom">s o l u t i o n s</div>
</div>
